import { memo } from 'react';

import { useToasts } from '../../model/selectors/select-toasts';
import { ToastCard } from '../toast-card';

const ToastContainerComponent = () => {
	const toasts = useToasts();

	if (!toasts.length) {
		return null;
	}

	return (
		<div className="fixed bottom-4 left-1/2 z-20000 flex max-w-[calc(100vw-2rem)] -translate-x-1/2 flex-col gap-4">
			{toasts.map((toast, index) => (
				<ToastCard key={toast.id} toast={toast} exceedTime={index > 4} />
			))}
		</div>
	);
};

export default memo(ToastContainerComponent);
